import { MAP_MAX_ZOOM, MARKING_MIN_ZOOM, SURVEY_MIN_ZOOM } from '../components/map/config/mapConfig';

export function clampLockZoom(zoom: number, mapMaxZoom = MAP_MAX_ZOOM): number {
  return Math.max(-2, Math.min(zoom, mapMaxZoom));
}

export interface ZoomLockSteps {
  z: number;
  maxBeforeMin: number;
  min: number;
  max: number;
}

/** Mapbox requires minZoom <= current maxZoom when setMinZoom runs. */
export function planZoomLock(
  currentMaxZoom: number,
  targetZoom: number,
  mapMaxZoom = MAP_MAX_ZOOM,
): ZoomLockSteps {
  const z = clampLockZoom(targetZoom, mapMaxZoom);
  return {
    z,
    maxBeforeMin: Math.max(z, currentMaxZoom),
    min: z,
    max: z,
  };
}

export interface ZoomLockMap {
  setMaxZoom: (z: number) => void;
  setMinZoom: (z: number) => void;
  setZoom: (z: number) => void;
  getMaxZoom: () => number;
}

export function applyZoomLock(
  map: ZoomLockMap,
  targetZoom: number,
  mapMaxZoom = MAP_MAX_ZOOM,
): void {
  const steps = planZoomLock(map.getMaxZoom(), targetZoom, mapMaxZoom);
  map.setMaxZoom(steps.maxBeforeMin);
  map.setMinZoom(steps.min);
  map.setMaxZoom(steps.max);
  map.setZoom(steps.z);
}

export interface SurveyMinZoomMap extends ZoomLockMap {
  getZoom: () => number;
}

/** During survey capture: allow zoom out for context, up to tile max; pan and pitch stay enabled. */
export function applySurveyMinZoom(
  map: SurveyMinZoomMap,
  _recommendedZoom = SURVEY_MIN_ZOOM,
  mapMaxZoom = MAP_MAX_ZOOM,
  markingMinZoom = MARKING_MIN_ZOOM,
): void {
  map.setMaxZoom(mapMaxZoom);
  map.setMinZoom(Math.min(markingMinZoom, mapMaxZoom));
}
